import { z } from 'zod';

import { EmailSchema } from '@vestigas/utils';

// Response schema for resending magic link email
// Field is `magic_link_supplier_email` on the wire (-> magicLinkSupplierEmail), not
// `supplier_email` - the API's MagicLinkResendResponse schema names it after the
// magic-link-specific field it mirrors (calloff.magic_link_supplier_email).
export const zodResendMagicLinkEmailResponseSchema = z.object({
  calloffId: z.uuid(),
  expiresAt: z.iso.datetime({ offset: true }),
  magicLinkSupplierEmail: EmailSchema,
  message: z.string(),
  success: z.boolean(),
});
